import styled from 'styled-components'
import { space } from 'styled-system'
import { IGrid } from './Grid'

export const StyledGrid = styled.div<IGrid>`
  max-width: 68rem;
  width: 100%;
  height: ${props => (props.fullHeight ? '100%' : 'auto')};
  margin-inline: auto;
  ${space}
`
